import { gql } from '@apollo/client'

export const UNVERIFY_CORRECTION = gql`
  mutation UnverifyCorrection($boxId: ID!, $feedbackNote: String) {
    unverifyCorrection(boxId: $boxId, feedbackNote: $feedbackNote) {
      __typename
      ... on ReviewUnverifyResult {
        success
      }
      ... on LeaseLockError {
        code
        message
      }
      ... on NoItemsAvailableError {
        code
        message
      }
    }
  }
`
